export default __webpack_public_path__ + "static/media/audio-icon-instruction-new.66abcd5a.svg";